<div class="internet-connection" [class.online]="uiService.isInternetConnection$ | async">
  {{(uiService.isInternetConnection$ | async) ? 'Online. Connection restored.' : 'Offline! Check your Internet connection.'}}
</div>
<router-outlet> </router-outlet>
